export default __webpack_public_path__ + "static/media/guest_14_02.9e810575.jpg";